import { useState } from 'react'
import { ProjectProps } from '../Project'
import { useTranslation } from 'react-i18next';
import { AuthModel } from '../../../utils/interfaces';
import Loading from '../../../components/Loading';
import { useAsyncEffect } from '../../../utils/functions';
import { getItem } from '../../../api/API';
import { tables } from '../../../utils/constants';
import { TbExternalLink } from 'react-icons/tb';
import MainBlock from '../../../components/MainBlock';
import Users from './Users';
import Password from './Password';
import Template from './Template';
import { useNavigate } from 'react-router-dom';
import { Title } from '../../../components/General';

const Auth = (props: ProjectProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [auth, setAuth] = useState<AuthModel | null>(null);
  const [management, setManagement] = useState<'users' | 'password' | 'template'>('users');

  const [isLoading, setIsLoading] = useState(true);

  // load auth data
  useAsyncEffect(async () => {
    if (!props.project.adminIds.find(a => a.userId === props.user!.id)) {
      navigate('/unauthorized');
      return;
    }
    const data: AuthModel = (await getItem(tables.auths, `${props.project.id}`)).item;
    setAuth(data);
    setIsLoading(false);
  }, [props.project]);

  return (
    isLoading ? <main className='flex items-center justify-center flex-1'><Loading solid size={8} /></main>
    : <>
      <div className='flex-1 flex flex-col p-4 md:px-8 overflow-hidden'>
        <div className='flex items-center justify-between gap-4'>
          <Title>{t('sidebar-menu.project.auth')}</Title>
        </div>
        <div className='flex-1 overflow-hidden mt-4 flex flex-col'>
          <MainBlock extraclass='flex-1 flex flex-col overflow-auto'>
            <div className='flex overflow-auto *:whitespace-nowrap'>
              <button onClick={() => setManagement('users')} className={`p-2 px-4 text-xs md:text-sm ml-2 border-b-2 ${management === 'users' ? 'border-primary' : 'border-transparent text-gray-400'}`}>{t('project.auth.users')}</button>
              <button onClick={() => setManagement('password')} className={`p-2 px-4 text-xs md:text-sm ml-2 border-b-2 ${management === 'password' ? 'border-primary' : 'border-transparent text-gray-400'}`}>{t('project.auth.password')}</button>
              <button onClick={() => setManagement('template')} className={`p-2 px-4 text-xs md:text-sm ml-2 border-b-2 ${management === 'template' ? 'border-primary' : 'border-transparent text-gray-400'}`}>{t('project.auth.template')}</button>
            </div>
            {management === 'users' ? auth && <Users {...props} auth={auth} />
            : management === 'password' ? auth && <Password {...props} auth={auth} setAuth={setAuth} /> 
            : management === 'template' ? auth && <Template {...props} auth={auth} setAuth={setAuth} />
            : <></>}
          </MainBlock>
        </div>
      </div>
    </>
  )
}

export default Auth